// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"0f45ed69","523":"064abc09","579":"95e8172b"}[chunkId] + ".chunk.js";
};